export class ProfileHelper {
    static GetProfileFromRole(role: string) : number {
        if (["D1", "D2"].includes(role)) return 4;
        else if (["E2", "E3"].includes(role)) return 5;
        else if (["E1", "E4"].includes(role)) return 8;
        else if (["F1"].includes(role)) return 6;
        else return 0;
    }
}